// Formattazione importi in italiano (1.234,56 €) senza dipendere dal supporto
// locale/ICU del browser, che in alcuni runtime non applica il separatore delle migliaia.
export function num(value, decimals = 2) {
  const n = Number(value || 0);
  const neg = n < 0;
  const fixed = Math.abs(n).toFixed(decimals);
  const [int, dec] = fixed.split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${neg ? "-" : ""}${grouped}${dec ? "," + dec : ""}`;
}

export function eur(value, decimals = 2) {
  return `${num(value, decimals)} €`;
}

// Variante compatta senza decimali (per KPI e grafici).
export function eur0(value) {
  return eur(value, 0);
}

// Nome visualizzato di un referente/persona (Cognome Nome).
export const nomeCompleto = (p) => [p?.cognome, p?.nome].filter(Boolean).join(" ");
